import * as Yup from "yup";

export const table = {
  primaryData: [
    {
      title: "Name",
      value: "global_name",
      type: "configue",
    },
    {
      title: "status",
      value: "status",
    },
    {
      title: "CreatedBy",
      value: "created_by_name",
      type: "configue",
    },
    {
      title: "CreatedAt",
      value: "created_at",
      type: "configue",
    },
    {
      title: "Actions",
      width: "5%",
      sendStatus: true,
    },
  ],
  secondaryData: [],
};

export type topic = {
  global_name: string;
  gcf_public_topic_id: string;
  status: string;
  topic_code: string;
  image_url: string;
  gcf_learn_topic_id: string;
  gcf_learn_topic_name: string;
  gcf_public_topic_name: string;
  npractice_public_topic_id: string;
  npractice_public_topic_name: string;
  npractice_practice_topic_id: string;
  npractice_practice_topic_name: string;
};

export const topicInitialValues: topic = {
  global_name: "",
  gcf_public_topic_id: "",
  status: "ACTIVE",
  topic_code: "",
  image_url: "",
  gcf_learn_topic_id: "",
  gcf_learn_topic_name: "",
  gcf_public_topic_name: "",
  npractice_public_topic_id: "",
  npractice_public_topic_name: "",
  npractice_practice_topic_id: "",
  npractice_practice_topic_name: "",
};

export const topicMandatoryFields = [{ id: "global_name" }];

export const topicValidationSchema = Yup.object().shape({
  global_name: Yup.string().required("Name is required"),
});

export const topicProperties = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "topic_code",
    type: "text",
    label: `Topic Code`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "image_url",
    type: "url-file-upload",
    label: "Image Url",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
];

export const topicPropertiesUpdate = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: true,
  },
  {
    id: "topic_code",
    type: "text",
    label: `Topic Code`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "image_url",
    type: "url-file-upload",
    label: "Image Url",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
    size: 10,
    feature: "global-content-hierarchy",
    fileType: [".jpg", ".png"],
    acceptTypes: "image/*",
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
  {
    id: "gcf_public_topic_id",
    type: "text",
    label: `Gcf Public topic id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "gcf_learn_topic_id",
    type: "text",
    label: `Gcf Learn Topic Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "gcf_learn_topic_name",
    type: "text",
    label: `Gcf Learn Topic Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "gcf_public_topic_name",
    type: "text",
    label: `Gcf Public Topic Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_public_topic_id",
    type: "text",
    label: `nPractice Public Topic Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_public_topic_name",
    type: "text",
    label: `nPractice Public Topic Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_practice_topic_id",
    type: "text",
    label: `nPractice Practice Topic Id`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "npractice_practice_topic_name",
    type: "text",
    label: `nPractice Practice Topic Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];
